module.exports = __webpack_public_path__ + "img/logo.230bf896.png";